export const API_URL = "https://globalsalesmeeting.arenasport.com/api/";
//export const API_URL = "http://localhost:8080/";
